import api from './api';

export const getTags = page => {
  return api.get('admin/Tag', {
    params: {
      page: page,
      limit: 10,
    },
  });
};

export const deleteTag = (id) => {
  return api.delete(`admin/tag/${id}`);
};

export const getTagsBySearch = (searchItem, search) => {
  return api.get(`admin/Tag?searchItem=${searchItem}&search=${search}`);
};

export const getTagsByOrder = (item, direction) => {
  return api.get(`admin/Tag?order=${item}&direction=${direction}`);
};

export const getTagIssue = (slug) => {
  return api.get (`issue/tag/${slug}`);
};

